import * as React from 'react'
import Typography from '@mui/material/Typography'

import { LightTooltip } from '@sales-center/components'
import { ClosingReqBtnSwitch } from './ClosingReqBtnSwitch'
import type { ClosingRequirementButtonProps } from './typings'

export function ClosingRequirementButton(props: ClosingRequirementButtonProps) {
  const { isDisabledText = '' } = props

  return (
    <LightTooltip title={isDisabledText}>
      <Typography component="span" width="100%">
        <ClosingReqBtnSwitch {...props} />
      </Typography>
    </LightTooltip>
  )
}
